<template>
    <div class="edit-box" v-if="state">
        <div class="popBox">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    指定商品
                    <span class="fr" @click="close"><i class="el-icon-close"></i></span>
                </div>
                <div class="popBody" ref="popBody">
                    <el-form ref="form" label-width="100px">
                        <el-form-item label="有效期至：" :rules="[
                                {required: true, message: '有效期无效', trigger: 'blur'}
                            ]">
                            <el-radio-group v-model="type">
                                <el-radio :label="1" class="radio-item">
                                    <el-date-picker
                                            v-model="dateValue"
                                            type="date"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="请选择日期">
                                    </el-date-picker>
                                </el-radio>
                                <div class="radio-blank"></div>
                                <el-radio :label="2">
                                    原有效期后
                                    <el-input v-model="dateDay" placeholder="" style="width: 60px" size="mini" />
                                    天
                                </el-radio>
                            </el-radio-group>
                            <div class="err-message" v-show="errMessage">{{errMessage}}</div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="popFoot">
                    <el-button @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button type="primary" @click="submit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "CardEditExpireTime",
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            selectedCardItem: {
                type: Object,
                default: ()=>({}),
            }
        },
        data: () => {
            return {
                type: 1,
                dateValue: "",
                dateDay: "",
                errMessage: "",
            }
        },
        methods: {
            init: function () {
                if(obj.isEmpty(this.selectedCardItem)) {
                    obj.message.error("请选择需要修改的卡项");
                    this.close();
                }
            },
            close: function () {
                this.$emit("stateChange", false);
            },
            submit: function () {
                //判断有效期是否合法
                if(this.type === 1 && obj.isEmpty(this.dateValue)){
                    obj.log(this.dateValue);
                    this.errMessage = "请选择有效日期";
                    return false;
                }else if(this.type === 2){
                    let day = Number(this.dateDay);
                    if(day < 1 || day > 3650){
                        this.errMessage = "请填写正确的天数[1-3650]之间";
                        return false;
                    }
                }else{
                    this.errMessage = "";
                }

                let postData = {
                    id: this.selectedCardItem.id,
                    type: this.type,
                    value: this.type === 1 ? this.dateValue : this.dateDay
                };
                obj.postData("card/set_sale_card_expire_date", postData, res => {
                    if(res.errcode === 0){
                        obj.message.success("设置成功");
                        this.$emit("successEvent");
                        this.close();
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            }
        },
        watch: {
            state: function (t) {
                if(t) this.init();
            },
            type: function (v) {
                this.errMessage = "";
            }
        }
    }
</script>

<style scoped>
    .edit-box{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
        z-index: 99;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
    }
    .popBox{
        width: 500px;
        background-color: #ffffff;
        border-radius: 3px;
    }
    .popBox .title{
        font-size: 18px;
        color: #333333;
    }
    .popBox .popBody{
        padding: 0px 20px;
        height: 120px;
    }
    .popFoot{
        text-align: right;
        padding: 10px 16px 6px;
    }
    .radio-item{
        margin-bottom: 20px;
    }
    .err-message{
        line-height: 30px;
        color: #df4545;
        font-size: 12px;
    }
</style>
